<div class="modal-header">
    <h2 class="modal-title">Add Person</h2>
</div>
<div class="modal-body">
    <dx-select-box [(value)]="personId" label="name" [items]="people" valueExpr="id" displayExpr="displayName"></dx-select-box>

    <!-- <dx-form [formData]="selectedPerson" [colCount]="1">
        <dxi-item
            dataField="selectedPerson"
            [label]="{ text: 'Name' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'displayName' }"
        ></dxi-item>
    </dx-form> -->
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
